import * as React from 'react'
import { connect } from 'react-redux'

import { filterChanged } from 'common/actions'
import { MultiProductState } from 'embed/reducers'
import { Filter, FilterPill, Product } from 'even-ts-static'
import Pill from './Pill'

export interface Props {
  dispatchRemoveFilter: (filter: Filter) => void
  pills: FilterPill[]
}

const SelectedFilterPills: React.FC<Props> = ({ dispatchRemoveFilter, pills }) => (
  <>
    {pills.map((pill) => (
      <Pill key={`${pill.filter}-${pill.label}`} onRemovePillClick={dispatchRemoveFilter} pillData={pill} />
    ))}
  </>
)

const mapStateToProps = (state: MultiProductState) => {
  const filters = state.filters[Product.Loan]
  const pills: FilterPill[] = []

  // For now, we'll hand-pick which filters will create pills.
  // In the future we may create a special type of 'filter' which includes a pill by default
  if (filters?.[Filter.LenderId] !== undefined) {
    const lenderLabel = state?.application[Product.Loan]?.fields?.lenderId?.lenderName ?? ''
    pills.push({
      filter: Filter.LenderId,
      label: lenderLabel,
    })
  }

  return {
    pills,
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatchRemoveFilter: (filter) => dispatch(filterChanged(Product.Loan, filter, undefined, { userInitiated: true })),
})

export default connect(mapStateToProps, mapDispatchToProps)(SelectedFilterPills)
